// window.cgiftnote = "";

function giftWrapModal() {
  const giftCards = document.querySelectorAll(
    ".gift_wrapper_drawer .cards .card"
  );

  giftCards.forEach((card) => {
    card.addEventListener("click", () => {
      giftCards.forEach((c) => {
        c.classList.remove("active");
      });

      card.classList.add("active");
    });
  });

  const wrapperTrigger = document.querySelector(
    "#cart-drawer .gift_wrapper_opener"
  );
  const wrapperCloser = document.querySelector(
    ".gift_wrapper_drawer .close_btn"
  );
  const wrapper = document.querySelector(".gift_wrapper_drawer");

  wrapperTrigger.addEventListener("click", () => {
    wrapper.classList.add("active");
  });

  wrapperCloser.addEventListener("click", () => {
    wrapper.classList.remove("active");
  });

  // add cart note
  const formSubmitBtn = document.querySelector(
    ".gift_wrapper_drawer .button_box .btn_primary"
  );
  const formCloseBtn = document.querySelector(
    ".gift_wrapper_drawer .button_box .btn_secondary"
  );
  const textBox = document.querySelector(
    ".gift_wrapper_drawer .textarea_box textarea"
  );

  formSubmitBtn.addEventListener("click", () => {
    const activeCard = document.querySelector(
      ".gift_wrapper_drawer .cards .card.active"
    );
    const type = activeCard.getAttribute("title");
    const giftNote = textBox.value;
    window.cgiftnote = giftNote;

    const giftProductCheckbox = document.querySelectorAll(
      ".gift_wrapper_drawer .pf-gift-cart-item"
    );

    let selectedItems = []

    giftProductCheckbox.forEach((item)=>{
      if(item.classList.contains("active")){
        const title = item.getAttribute("title");
        selectedItems.push(title);
      }
    })

  const note = selectedItems.length
  ? `${selectedItems.length} artikelen | ${type}${giftNote ? ` | incl. ${giftNote} ---` : " ---"} ${selectedItems.join(", ")}`
  : `${type}${giftNote ? ` | incl. ${giftNote}` : ""}`;

    updateNote(note);
    addGiftProduct();
  });

  formCloseBtn.addEventListener("click", () => {
    wrapper.classList.remove("active");
    textBox.value = giftNote;
  });

  const giftProductCheckbox = document.querySelectorAll(
    ".gift_wrapper_drawer .pf-gift-cart-item"
  );

  const giftProductDeselector = document.querySelector(
    ".gift_wrapper_drawer .pf-gift-cart-item-deselector"
  );

  if (giftProductCheckbox.length) {
    giftProductCheckbox.forEach((card) => {
      const checkbox = card.querySelector(".checkbox");
      
      checkbox.addEventListener("click", ()=>{
        if(card.classList.contains("active")){
          setTimeout(()=>{
            card.classList.remove("active");
          }, 500);
        } else {
          setTimeout(()=>{
            card.classList.add("active");
          }, 500);
        }
      });
    });

    giftProductDeselector.addEventListener("click", () => {
      let state = false;
      giftProductCheckbox.forEach((elm) => elm.classList.contains("active") ? state = true : null);

      setTimeout(()=>{
        if (state) {
          giftProductDeselector.innerHTML = "Selecteer al mijn artikelen";
          giftProductCheckbox.forEach(elm => elm.classList.remove("active"));
        } else {
          giftProductDeselector.innerHTML = "Deselecteer al mijn artikelen";
          giftProductCheckbox.forEach(elm => elm.classList.add("active"));
        }
      }, 1000)
    });
  }

  async function addGiftProduct() {
    let notSelectedVariants = [];
    let selectedVariant;

    giftCards.forEach((card) => {
      let value = card.getAttribute("value");
      if (card.classList.contains("active")) {
        selectedVariant = value;
      } else {
        notSelectedVariants.push(value);
      }
    });

    const res = await fetch("/cart.json");
    const cart = await res.json();
    // const removeFromCart = cart.items.filter((item)=> notSelectedVariants.includes(item.variant_id));
    const filterCart = cart.items.filter(
      (item) => item.variant_id == selectedVariant
    );

    const removePromises = cart.items
      .map((item, index) => {
        if (notSelectedVariants.includes(item.variant_id.toString())) {
          return fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              line: index + 1, // Shopify uses 1-based line numbers
              quantity: 0,
            }),
          });
        }
        return null;
      })
      .filter(Boolean); // remove nulls

    await Promise.all(removePromises);

    if (filterCart.length) return 0;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        quantity: 1,
        id: selectedVariant,
      }),
    })
      .then((response) => {
        $("drawer-element").load(location.href + " #cart-drawer");

        setTimeout(() => {
          initSlider();
          giftWrapModal();
        }, 5000);
      })
      .catch((error) => {
        console.error("Error adding gift wrapper:", error);
      });
  }

  function updateNote(note) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        note,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Note updated:", cart.note);
        textBox.value = window.cgiftnote;
        wrapper.classList.remove("active");
      })
      .catch((error) => {
        console.error("Error updating cart note:", error);
      });
  }

  initSlider();
}

function initSlider(){
  const cartSlider = document.querySelectorAll(".pf-cart-related-product-slider");
  const cardSlider = document.querySelectorAll(".pf-product-card-slider-outer");

  console.log('cartSlider', cartSlider);

  cartSlider.forEach((slide)=>{
    new Swiper(slide, {
      slidesPerView: 2.1,
      spaceBetween: 4,
      loop: true,
      navigation: {
        nextEl: slide.querySelector(".swiper-button-next"),
        prevEl: slide.querySelector(".swiper-button-prev"),
      },
    });
  });

  cardSlider.forEach((slide)=>{
    const pagination = slide.querySelectorAll(":scope > .swiper-pagination .swiper-pagination-bullet");

    const swiper = new Swiper(slide, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: slide.querySelector(":scope > .swiper-button-next"),
        prevEl: slide.querySelector(":scope > .swiper-button-prev"),
      },
      on: {
        slideChange(swiper) {
          // Clear existing active classes
          pagination.forEach((bullet) =>
            bullet.classList.remove("swiper-pagination-bullet-active")
          );

          // swiper.realIndex is the actual index (ignores duplicated looped slides)
          const activeIndex = swiper.realIndex % pagination.length;

          // Set the active bullet
          pagination[activeIndex]?.classList.add("swiper-pagination-bullet-active");
        },
      },
    });
  });

  popUpLoader();
}


function popUpLoader() {
    const popUpOpeners = document.querySelectorAll('.pf-product-card .pf-quickshop-button-card');
    const popUpOpenersCart = document.querySelectorAll('.pf-product-card .pf-quickshop-button-cart');
    const selects = document.querySelectorAll('.pf_quickshop_modal_wrapper .pf-product-sizeBox .jb_size_seclector');
    const modals = document.querySelectorAll('.pf_quickshop_modal_wrapper');

    popUpOpeners.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const card = btn.closest('.pf-product-card');
        const modal = card.querySelector('.pf_quickshop_modal_wrapper');

        modal.classList.add('active');
      });
    });

    popUpOpenersCart.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const id = btn.getAttribute('product-id');
        const modal = document.querySelector(`.pf_quickshop_modal_wrapper[product-id="${id}"]`);
        
        if (modal) {
          document.querySelector("body").click();
          document.querySelector("body").click();
          modal.classList.add('active');
        }
      });
    });

    modals.forEach((modal) => {
      const closeBtn = modal.querySelector(".close_button");
      
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          modal.classList.remove("active");
        });
      }

      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.classList.remove('active');
        }
      });
    });

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        const selectedValue = select.value;

        const modal = select.closest('.pf_quickshop_modal_wrapper');
        const input = modal.querySelector('product-form input[name="id"]'); // or use `.product-form` if it's a class
        const mainAtcButton = modal.querySelector('.product-form .product-form__buttons .button');
        const atcText = mainAtcButton.getAttribute("atc-text");
        const soldText = mainAtcButton.getAttribute("sold-text");

        if (!modal || !input) {
          console.warn('Modal or input not found.');
          return;
        }

        const variants = JSON.parse(modal.getAttribute('data-variants'));

        // Try to find the variant whose title or option matches selectedValue
        const matchedVariant = variants.find((variant) => {
          return variant.title.toLowerCase().includes(selectedValue.toLowerCase());
        });

        if (matchedVariant.available) {
          mainAtcButton.innerHTML = `<span data-add-to-cart-button-text=""><p>${atcText}</p></span>`;
          mainAtcButton.removeAttribute('disabled', false);
        } else {
          mainAtcButton.innerHTML = `<span data-add-to-cart-button-text=""><p>${soldText}</p></span>`;
          mainAtcButton.setAttribute('disabled', true);
        }

        if (matchedVariant) {
          input.value = matchedVariant.id;
        } else {
          console.warn('No matching variant found for value:', selectedValue);
        }
      });
    });

    function variantStatus(select) {
      const modal = select.closest('.pf_quickshop_modal_wrapper');
      const variants = JSON.parse(modal.getAttribute('data-variants'));

      console.log('select.value ====> ', select.value);
    }
}

// custom func observe cart drawer
function observeCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer'); // change selector if needed
  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    let precom = document.querySelector('product-recommendations.product-recommendations .swiper-initialized');
    if(precom) return;
    
    initSlider();
    giftWrapModal();
  });

  observer.observe(cartDrawer, {
    childList: true,     // watches for added/removed nodes
    subtree: true,       // watches all descendants
    attributes: true,    // watches for attribute changes
    characterData: true, // watches for text/content changes
  });
}

// Call it once after cart drawer is mounted
observeCartDrawer();